// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"920433f7","455":"ee871c01","977":"c67991df"}[chunkId] + ".chunk.js";
};